
const mappboxAPI =process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const zoomScales = {
  region: 8 ,  
  postcode: 11 ,  
  district: 11 ,  
  place: 12 , 
  locality: 12 ,  
  neighborhood: 14 ,  
  address: 19 ,  
  poi: 19 ,  
  "poi.landmark": 19
}

export default {
  name: 'geocoder',

  getReducer(){
    const initialState = {
      shouldRegister: true,
      shouldHandleSelect: false,
      selectedItem: null
    }

    return (state = initialState, { type, payload }) => {

      if(type === 'SEARCH_ITEM_SELECTED'){
        if(payload.selected.provider && payload.selected.provider === 'geocoder'){
          return Object.assign({}, state, {
            shouldHandleSelect: true,
            selectedItem: payload.selected
          })
        }
      }

      if(type.indexOf('GEOCODER_') !== -1){
        return Object.assign({}, state, payload);
      }

      return state;
    }
  },

  doGeocoderRegister: () => ({dispatch, store}) => {
    dispatch({ type: 'GEOCODER_REGISTERED', payload: { shouldRegister: false }});
    store.doSearchAddCollection({
      onFireSearch: store.doGeocoderFireSearch
    })
  },

  doGeocoderHandleSelect: () => ({dispatch, store}) => {
    dispatch({ type: 'GEOCODER_HANDLED_SELECT', payload: { shouldHandleSelect: false }});
    const selectedItem = store.selectGeocoderLastSelected();
    if(selectedItem && selectedItem.provider === 'geocoder'){
      store.doSetView({
        center: selectedItem.center,
        zoom: selectedItem.zoom
      });
    }
  },

  doGeocoderFireSearch: (callback) => ({dispatch, store, apiGet}) => {
    let q = store.selectSearchQueryString();
    let c = store.selectViewCenter();
    if(q.length < 2) return;
    q = encodeURIComponent(q);
    apiGet(`https://api.mapbox.com/geocoding/v5/mapbox.places/${q}.json?proximity=${c.toString()}&access_token=${mappboxAPI}`,
      (err, response, body) => {
        if(err) return callback(err);

        const results = JSON.parse(body);

        return callback(null, function(){
          if (results && results.features.length>0) {
            return results.features.map((r) => {
              let icon = 'mdi mdi-map-marker';
              if(r.properties.maki) icon = `maki maki-${r.properties.maki}`;
              const z = zoomScales[r.place_type[0]] || 11;
              return {
                provider: 'geocoder',
                priority:9999,
                displayName: r.place_name,
                place_type: r.place_type,
                iconClass: icon,
                center: r.center,
                zoom: z,
                geometry: r.geometry,
                properties: r.properties
              }
            })
          }else{
            return 
          }
        }
        )
      }
    );
  },

  selectGeocoderLastSelected: (state) => {
    return state.geocoder.selectedItem;
  },

  reactGeocoderShouldHandleSelect: (state) => {
    if(state.geocoder.shouldHandleSelect) return { actionCreator: 'doGeocoderHandleSelect' };
  },

  reactGeocoderShouldRegister: (state) => {
    if(state.geocoder.shouldRegister) return { actionCreator: 'doGeocoderRegister' };
  }
}